import type { ButtonProps } from '../../button';
import { Button } from '../../button';
import { ChevronUp, Icon } from '@components/atoms';
import type { IconProps } from '@components/atoms/icons/icon';
import { cn } from '@utils';

type ChevronButtonProps = Omit<ButtonProps, 'children' | 'type'> &
	Partial<Pick<IconProps, 'color'>> & {
		'data-testid'?: string;
		isExpanded: boolean;
	};

export const ChevronButton = ({
	className,
	isExpanded,
	size = 'lg',
	color = 'element',
	...rest
}: ChevronButtonProps) => {
	return (
		<Button
			type="button"
			iconButton
			variant="tertiaryNew"
			className={className}
			size={size}
			data-testid={rest['data-testid'] || 'chevron-button'}
			{...rest}
		>
			<Icon
				className={cn('transition-transform duration-150 ease-in-out', isExpanded ? 'rotate-0' : '-rotate-180')}
				size={size}
				color={color}
			>
				<ChevronUp />
			</Icon>
		</Button>
	);
};
